import { c as _c } from "react/compiler-runtime";
import type { Money } from '@newfront-insurance/core-money';
import { toMoneyOrUndefined, toNumberOrUndefinedFromMoney } from '@newfront-insurance/core-money';
import { CurrencyInput, Field, Flexbox, Input } from '@newfront-insurance/core-ui';
import get from 'lodash/get';
import type { JSX } from 'react';
type CurrencyWithNumber = Record<string, Money | number | undefined> | undefined;
interface Props {
  name: string;
  value?: CurrencyWithNumber;
  onChange: (value: CurrencyWithNumber) => void;
  currencyFieldLabel?: string;
  currencyFieldName: string;
  numberFieldLabel?: string;
  numberFieldName: string;
  decimalScale?: number;
  appendText?: string;
  disabled?: boolean;
}
export function CurrencyWithNumber(props) {
  const $ = _c(40);
  const {
    onChange,
    name,
    value,
    currencyFieldLabel,
    currencyFieldName,
    numberFieldLabel,
    numberFieldName,
    decimalScale,
    appendText,
    disabled
  } = props;
  let t0;
  if ($[0] !== currencyFieldName || $[1] !== numberFieldName || $[2] !== onChange) {
    t0 = function handleChange(newValue) {
      const currencyValue = newValue?.[currencyFieldName] as Money;
      const numberValue = newValue?.[numberFieldName] as number;
      if (!currencyValue && !numberValue) {
        onChange(undefined);
        return;
      }
      onChange({
        [currencyFieldName]: currencyValue,
        [numberFieldName]: numberValue
      });
    };
    $[0] = currencyFieldName;
    $[1] = numberFieldName;
    $[2] = onChange;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleChange = t0;
  const t1 = currencyFieldLabel || "";
  const t2 = `${name}.${currencyFieldName}`;
  const t3 = `${name}.${currencyFieldName}`;
  let t4;
  if ($[4] !== currencyFieldName || $[5] !== value) {
    t4 = toNumberOrUndefinedFromMoney(get(value, currencyFieldName) as Money);
    $[4] = currencyFieldName;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== currencyFieldName || $[8] !== handleChange || $[9] !== value) {
    t5 = inputValue => handleChange({
      ...value,
      [currencyFieldName]: toMoneyOrUndefined(inputValue)
    });
    $[7] = currencyFieldName;
    $[8] = handleChange;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== decimalScale || $[12] !== disabled || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <CurrencyInput name={t3} value={t4} decimalScale={decimalScale} onChange={t5} disabled={disabled} />;
    $[11] = decimalScale;
    $[12] = disabled;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t6) {
    t7 = <Field label={t1} fieldId={t2}>{t6}</Field>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = numberFieldLabel || "";
  const t9 = `${name}.${numberFieldName}`;
  let t10;
  if ($[21] !== numberFieldName || $[22] !== value) {
    t10 = get(value, numberFieldName) as number | undefined || "";
    $[21] = numberFieldName;
    $[22] = value;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== handleChange || $[25] !== numberFieldName || $[26] !== value) {
    t11 = inputValue_0 => {
      const newNumberValue = inputValue_0 ? Number(inputValue_0) : undefined;
      handleChange({
        ...value,
        [numberFieldName]: newNumberValue as number
      });
    };
    $[24] = handleChange;
    $[25] = numberFieldName;
    $[26] = value;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== appendText || $[29] !== disabled || $[30] !== t10 || $[31] !== t11) {
    t12 = <Input type="number" value={t10} onChange={t11} appendText={appendText} disabled={disabled} />;
    $[28] = appendText;
    $[29] = disabled;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t8 || $[35] !== t9) {
    t13 = <Field label={t8} fieldId={t9}>{t12}</Field>;
    $[33] = t12;
    $[34] = t8;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== t7) {
    t14 = <Flexbox gap={16} flexDirection="row">{t7}{t13}</Flexbox>;
    $[37] = t13;
    $[38] = t7;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}